var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10098 6.91678H3.05469V3.05566H6.9158V4.10196H4.13802L4.10098 6.91678ZM4.10098 13.0834H3.05469V16.9446H6.9158V15.9075H4.13802L4.10098 13.0834ZM13.0825 3.05566V4.10196H15.8602V6.87974H16.9436V3.05566H13.0825ZM15.8602 15.9075H13.0825V16.9446H16.9436V13.0834H15.9065L15.8602 15.9075ZM14.8139 12.7501L9.99913 15.4168L5.2121 12.7501V7.25011L9.99913 4.62974L14.8139 7.25011V12.7501ZM9.50839 10.2409L6.25839 8.44455V12.1483L9.48061 13.9446L9.50839 10.2409ZM10.0269 9.31492L13.2214 7.52789L9.99913 5.77789L6.80469 7.55566L10.0269 9.31492ZM13.7306 8.389L10.5084 10.1853V13.889L13.7306 12.0927V8.389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceprofile);
export default __webpack_public_path__ + "static/media/Deviceprofile.9ce8dec5e29a3e2c807b7ec800403626.svg";
export { ForwardRef as ReactComponent };